<template>
  <div class="cp-countdown-animations">
    <animation-renault
      :background="desktopBackground"
      :strength-x-x="strengthXX"
      :strength-x-y="strengthXY"
      :strength-y-x="strengthYX"
      :strength-y-y="strengthYY"
      v-if="brand === 'renault'"
    />
    <animation-dacia
      v-else-if="brand === 'dacia'"
      :assets-url="assetsUrl"
    />
    <animation-default
      v-else
      :desktop-background="desktopBackground"
      :mobile-background="mobileBackground"
    />
  </div>
</template>

<script>
import AnimationRenault from './Countdown/AnimationRenault';
import AnimationDefault from './Countdown/AnimationDefault';
import AnimationDacia from './Countdown/AnimationDacia';

export default {
  components: {
    AnimationRenault,
    AnimationDefault,
    AnimationDacia,
  },

  props: {
    brand: {
      type: String,
      required: true,
    },
    desktopBackground: {
      type: String,
      required: true,
    },
    mobileBackground: {
      type: String,
      required: true,
    },
    assetsUrl: {
      type: String,
      required: true,
    },
    strengthXX: {
      required: false,
      default: '4.0',
      validator(value) {
        return parseFloat(value.match(/^-?\d*(\.\d+)?$/)) > 0;
      },
    },
    strengthXY: {
      required: false,
      default: '2.0',
      validator(value) {
        return parseFloat(value.match(/^-?\d*(\.\d+)?$/)) > 0;
      },
    },
    strengthYX: {
      required: false,
      default: '2.0',
      validator(value) {
        return parseFloat(value.match(/^-?\d*(\.\d+)?$/)) > 0;
      },
    },
    strengthYY: {
      required: false,
      default: '2.0',
      validator(value) {
        return parseFloat(value.match(/^-?\d*(\.\d+)?$/)) > 0;
      },
    },
  },
}
</script>
